import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 4219" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8013",
    d: "M8 17H4.524l4.095 18.878H22.5L25.935 17zm14.04 3.432-2.112 12.014h-8.581L8.619 20.432z",
    transform: "translate(-4.524 8.122)",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8014",
    d: "M31.879 2.719A18.669 18.669 0 0 0 15.45 5.82 18.919 18.919 0 0 0 8 20.876a22.118 22.118 0 0 0 .154 2.386l.2 1.133h3.411a15.5 15.5 0 0 1 5.715-15.75 15.308 15.308 0 0 1 22.754 4.965 15.525 15.525 0 0 1-1.284 16.717 15.357 15.357 0 0 1-7 5.171 15.058 15.058 0 0 1-6.277.858l-.409 3.432A18.677 18.677 0 0 0 38.52 36.13a18.91 18.91 0 0 0-6.641-33.411z",
    transform: "translate(-2.035 -2.003)",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8015",
    d: "M17 8v12.013h13.73v-3.432h-10.3V8z",
    transform: "translate(4.245 2.098)",
    style: {"fill":"#fff"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };